import { GRAPHQL_AUTH_MODE, GraphQLQuery } from "@aws-amplify/api"
import { API, Auth } from "aws-amplify"
import * as queries from "../../graphql/queries";
import { GetImageGenerationResultsQuery, GetImageGenerationResultsQueryVariables } from "../../API";
import { IImageGenerationDataModel } from "../../types/imageGeneration";

export const loadImageGenerationResults = async (pageSize: number = 20, createdBy: string, isSeeAll: boolean) => {
    const currentSession = await Auth.currentSession();
    const currentUserEmail = String(currentSession.getIdToken().payload["email"]);
    let createdByQuery = "";
    if (!isSeeAll) {
        if (createdBy.length > 0) {
            createdByQuery = createdBy.toLowerCase();
        }
        if (createdBy.length === 0) {
            createdByQuery = currentUserEmail.toLowerCase();
        }
    }
    const response = await API.graphql<GraphQLQuery<GetImageGenerationResultsQuery>>({
        query: queries.getImageGenerationResults,
        variables: {
            pageSize: pageSize,
            createdBy: createdByQuery
        } as GetImageGenerationResultsQueryVariables,
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
    })
    let parsedResults = JSON.parse(response.data?.getImageGenerationResults || "{}");
    const result: IImageGenerationDataModel[] = Array.isArray(parsedResults.items)
        ? parsedResults.items.map((item: IImageGenerationDataModel) => ({
            ...item,
            feedback_rating: item.hasOwnProperty('feedback_rating') ? item.feedback_rating : null,
            feedback_text: item.hasOwnProperty('feedback_text') ? item.feedback_text : null,
        }))
        : [];
    
    return result;
}